module.exports = __webpack_public_path__ + "static/images/cancel.1ocf7pa.svg";